import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import ModalButtons from '../../components/Modal/ModalButtons';

const UserQuotaReachedModal = ({ maxUserQuotaModal, handleMaxUserQuotaModalClose }) => {
	const { t } = useTranslation();
	return (
		<Modal show={maxUserQuotaModal}>
			<ModalHeading heading={t('screens.users.quotaTitle')} />
			<ModalForm style={{ marginBottom: '2.5rem' }}>
				<InputsSection style={{ width: '34rem' }}>
					<p className='primaryText'>{t('screens.users.quotaBody')}</p>
				</InputsSection>
				<ModalButtons cancelButtonLabel={t('screens.users.close')} onCancel={handleMaxUserQuotaModalClose} />
			</ModalForm>
		</Modal>
	);
};

export default UserQuotaReachedModal;
